class SizeFinder extends HTMLElement {
  connectedCallback() {
    this.selectedQuantity = null;
    this.form = this.querySelector('.size-finder-steps__form');
    this.drawer = this.closest('size-finder-drawer');
    this.adultUrl = this.getAttribute('data-adult-url') || ''; // produit adulte équivalent (tableaux ado)
    this.steps = Array.from(this.form.querySelectorAll('.size-finder-step'));
    this.currentStep = 0;
    this.isMobile = window.innerWidth <= 749;
    this.inputs = [
      this.form.querySelector('#size_finder_hip_measure'),
      this.form.querySelector('#size_finder_waist_measure'),
      this.form.querySelector('#size_finder_height_measure')
    ];
    this.resultStep = this.form.querySelector('.step--result');
    this.resultSpan = this.resultStep.querySelector('.step--result .step--result-label');
    this.resultsPad = this.resultStep.querySelector('.step--pad');
    this.selectBtn = this.form.querySelector('[data-action="select-this-size"]');
    this.disableAllNextButtons();
    this.attachEvents();
    this.updateSteps();
  }

  saveSelectedQuantity() {
    const checked = document.querySelector('input[type="radio"][name="quantity"]:checked');
    this.selectedQuantity = checked ? checked.value : null;
    console.log('Selected quantity saved:', this.selectedQuantity);
  }

  restoreSelectedQuantity() {
    if (!this.selectedQuantity) return;
    const radio = document.querySelector(`input[type="radio"][name="quantity"][value="${this.selectedQuantity}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  disableAllNextButtons() {
    this.steps.forEach((step) => {
      const btn = step.querySelector('[data-action="next"]');
      if (btn) btn.disabled = true;
    });
  }

  attachEvents() {
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 749;
    });

    this.form.addEventListener('click', (e) => {
      const nextBtn = e.target.closest('[data-action="next"]');
      const backBtn = e.target.closest('.link');
      const retryBtn = e.target.closest('.step--result .size-finder-step__footer--step.link');
      if (nextBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.goToNextStep();
      } else if (backBtn && !retryBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.goToPrevStep();
      } else if (retryBtn) {
        e.stopPropagation();
        e.preventDefault();
        this.reset();
      }
    });

    this.inputs.forEach((input, idx) => {
      if (!input) return;

      input.addEventListener('input', () => {
        this.validateInput(idx);
      });

      // Gestion du clavier numérique
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === 'Go' || e.key === 'Next') {
          e.preventDefault();
          e.stopPropagation();

          if (this.isMobile) {
            input.blur();
            return;
          }

          if (idx !== this.currentStep) return;
          const { valid } = this.getInputValidation(this.currentStep);
          if (valid) {
            this.goToNextStep();
          } else {
            this.validateInput(this.currentStep);
          }
        }
      });

      // Problème sur mobile : niveau de la touche entrée/"suivant" qui fonctionne à moitié ; workaround pour valider l'étape
      if (this.isMobile) {
        input.addEventListener('blur', () => {
          setTimeout(() => {
            const { valid } = this.getInputValidation(this.currentStep);
            if (valid) {
              this.goToNextStep();
            } else {
              this.validateInput(this.currentStep);
            }
          }, 100);
        });
      }
    });

    if (this.selectBtn) {
      this.selectBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const sizeLabel = this.resultSpan?.getAttribute('data-size-label');
        this.selectVariantBySizeLabel(sizeLabel);
      });
    }
  }

  selectVariantBySizeLabel(sizeLabel) {
    if (!sizeLabel) return this.drawer?.closeDrawer(true);
    const variantMapScript = document.getElementById('variant-size-map');
    if (!variantMapScript) return this.drawer?.closeDrawer();
    let variants = [];
    try {
      variants = JSON.parse(variantMapScript.textContent);
    } catch (e) {
      return this.drawer?.closeDrawer();
    }
    const normalize = str => (str || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    const variant = variants.find(v => v.title && normalize(v.title).startsWith(normalize(sizeLabel)));
    if (variant) {
      let variantSelected = false;
      const radio = document.querySelector(`input[type="radio"][value="${variant.title}"]`);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        variantSelected = true;
      }
    }
    const radio = document.querySelector(`input[type="radio"][name="quantity"][value="${this.selectedQuantity}"]`);
    if (radio) {
      const observer = new MutationObserver((mutations, obs) => {
        this.restoreSelectedQuantity();
        this.drawer?.closeDrawer(true);
        obs.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Arrêt après 2s si jamais rien ne se passe
      setTimeout(() => {
        observer.disconnect();
        this.restoreSelectedQuantity();
        this.drawer?.closeDrawer(true);
      }, 2000);
    } else {
      this.drawer?.closeDrawer(true);
    }
  }

  validateInput(idx) {
    const { valid } = this.getInputValidation(idx);
    const step = this.steps[idx];
    const btn = step.querySelector('[data-action="next"]');
    if (btn) btn.disabled = !valid;
    if (!valid && this.inputs[idx].value !== '') {
      step.classList.add('has-error');
    } else {
      step.classList.remove('has-error');
    }
  }

  getInputValidation(idx) {
    const input = this.inputs[idx];
    const min = input.min !== '' ? parseFloat(input.min) : null;
    const max = input.max !== '' ? parseFloat(input.max) : null;
    const value = input.value !== '' ? parseFloat(input.value) : null;
    let valid = value !== null && !isNaN(value);
    if (valid && min !== null && value < min) valid = false;
    if (valid && max !== null && value > max) valid = false;
    return { valid, value, min, max };
  }

  goToNextStep() {
    if (this.currentStep < this.steps.length - 1) {
      if (this.currentStep < this.inputs.length) {
        const { valid } = this.getInputValidation(this.currentStep);
        if (!valid) {
          this.steps[this.currentStep].classList.add('has-error');
          return;
        } else {
          this.steps[this.currentStep].classList.remove('has-error');
        }
      }
      this.currentStep++;
      this.updateSteps();
    }
  }

  goToPrevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.updateSteps();
    }
  }

  updateSteps() {
    this.inputs.forEach((input, idx) => {
      if (input && idx <= this.currentStep) {
        this.validateInput(idx);
      }
    });

    this.steps.forEach((step, idx) => {
      if (idx === this.currentStep) {
        if (this.isMobile) {
          step.scrollIntoView({
            behavior: 'auto', // Pas de smooth sur mobile
            inline: 'start',
            block: 'nearest'
          });
        } else {
          step.scrollIntoView({
            behavior: 'smooth',
            inline: 'start',
            block: 'nearest'
          });
        }

        /*         
        A décommenter si besoin de focus sur l'input de l'étape courante
        
        const currentInput = this.inputs[this.currentStep];
                if (currentInput) {
                  setTimeout(() => {
                    currentInput.focus();
                  }, this.isMobile ? 100 : 300);
                } 
                  */
      }
    });

    if (this.currentStep === this.steps.length - 1) {
      this.showResult();
    }
  }

  showResult() {
    if (this.resultSpan) {
      const hip = this.inputs[0]?.value || '-';
      const waist = this.inputs[1]?.value || '-';
      const height = this.inputs[2]?.value || '-';

      const tableData = document.getElementById('size-table-data');

      const isAgeLabel = label => /^\d{1,2}\/\d{1,2}\s*ans$/i.test((label || '').trim());
      const isSizeLabel = label => /^(xs|s|m|l|xl|xxl)$/i.test((label || '').trim());
      // libellé "effectif" : on prend label, sinon labelOverride (certains tableaux ne remplissent que labelOverride)
      const effLabel = size => {
        const l = (size.label || '').trim();
        return l !== '' ? l : (size.labelOverride || '').trim();
      };

      // Il y a (évidemment) un seul tableau qui contient des ages (11/12 ans ...) et des tailles (XS, S, ..) 
      // cas particulier : on se base sur le fait qu'il y a au moins un label d'age pour afficher null sur les résultats de taille
      let tableHasAgeLabels = false;
      if (tableData) {
        try {
          const data = JSON.parse(tableData.textContent);
          if (Array.isArray(data)) {
            tableHasAgeLabels = data.some(row => isAgeLabel(row.label) || isAgeLabel(row.labelOverride));
          }
        } catch (e) {
          console.error('[E1] Erreur lors de l\'analyse des données JSON :', e);
        }
      }
      let sizeLabel = '';
      let colorLabel = '';
      let redirectSize = ''; // taille adulte (XS/S...) détectée dans un tableau ado -> redirection produit
      let usedFallback = false; // true si la taille vient du repli "tour de taille prioritaire"
      if (tableData) {
        try {
          const data = JSON.parse(tableData.textContent);
          if (Array.isArray(data)) {
            const hipVal = parseFloat(hip);
            const waistVal = parseFloat(waist);
            const heightVal = parseFloat(height);
            const heightOk = size => isNaN(heightVal) || size.heightMax == null || heightVal <= size.heightMax;

            // 1) Correspondance EXACTE : tour de taille ET tour de hanches (+ hauteur si saisie)
            let found = data.find(size =>
              waistVal >= size.waistMin && waistVal <= size.waistMax &&
              hipVal >= size.hipsMin && hipVal <= size.hipsMax &&
              heightOk(size)
            );

            // 2) REPLI "tour de taille prioritaire" : si aucune case exacte, la taille est
            //    décidée par le tour de taille. On reste sur la ligne du tour de taille et on
            //    rapproche les hanches de la case définie la plus proche (départage uniquement).
            if (!found) {
              let best = null;
              data.forEach(size => {
                if (waistVal < size.waistMin || waistVal > size.waistMax || !heightOk(size)) return;
                const hipDist = hipVal < size.hipsMin ? size.hipsMin - hipVal
                              : hipVal > size.hipsMax ? hipVal - size.hipsMax
                              : 0;
                if (best === null || hipDist < best.hipDist) best = { size, hipDist };
              });
              if (best) { found = best.size; usedFallback = true; }
            }

            if (found) {
              const eff = effLabel(found);
              if (tableHasAgeLabels && isSizeLabel(eff)) {
                // Tableau "par âge" mais la cliente correspond à une taille adulte (XS/S...).
                // On ne sélectionne PAS de variante ado (elle n'existe pas) -> redirection produit adulte.
                redirectSize = eff;
              } else if (eff) {
                sizeLabel = eff;
                colorLabel = found.color;
              }
            }
          }
        } catch (e) {
          console.error('Erreur lors de l\'analyse des données JSON :', e);
        }
      }
      const hasResult = !!sizeLabel;        // taille ado sélectionnable
      const isRedirect = !!redirectSize;    // taille adulte -> rediriger
      const noResult = !hasResult && !isRedirect;

      const q = sel => this.resultStep.querySelector(sel);

      // État 1 : taille ado (sélection de variante)
      this.resultsPad.querySelector('.step--result').style.display = hasResult ? 'flex' : 'none';
      q('.step--with-result-title').style.display = hasResult ? 'block' : 'none';
      q('.step--desc-with-result').classList.toggle('hidden', !hasResult);
      // Note explicative affichée uniquement si la taille vient du repli "tour de taille"
      const approxNote = q('.step--desc-approx');
      if (approxNote) approxNote.classList.toggle('hidden', !(hasResult && usedFallback));
      if (this.selectBtn) this.selectBtn.style.display = hasResult ? 'block' : 'none';

      // État 2 : redirection vers le produit adulte équivalent
      const redirectEl = this.resultsPad.querySelector('.step--redirect');
      const redirectLabelEl = this.resultsPad.querySelector('.step--redirect-label');
      const redirectDesc = q('.step--desc-redirect');
      const redirectCta = q('.step--redirect-cta');
      if (redirectEl) redirectEl.style.display = isRedirect ? 'flex' : 'none';
      if (redirectLabelEl) redirectLabelEl.textContent = redirectSize;
      if (redirectDesc) redirectDesc.classList.toggle('hidden', !isRedirect);
      if (redirectCta) {
        if (isRedirect && this.adultUrl) {
          redirectCta.href = this.adultUrl;
          redirectCta.style.display = 'block';
        } else {
          redirectCta.style.display = 'none';
        }
      }

      // État 3 : aucun résultat
      q('.step--no-result').style.display = noResult ? 'flex' : 'none';
      q('.step--desc-no-result').classList.toggle('hidden', !noResult);

      // Valeur de taille (utilisée par la sélection de variante)
      this.resultSpan.setAttribute('data-size-label', sizeLabel);
      this.resultSpan.textContent = sizeLabel;
      this.resultsPad.style.setProperty('--size-color', (colorLabel && colorLabel != '#FFFFFF') ? colorLabel : '#E4ECF0');
    }
  }

  reset() {
    this.inputs.forEach(input => { if (input) input.value = ''; });
    this.currentStep = 0;
    this.updateSteps();
    this.disableAllNextButtons();
    this.steps.forEach(step => step.classList.remove('has-error'));
  }
}

if (!customElements.get('size-finder')) {
  customElements.define('size-finder', SizeFinder);
}